import DialogForm from '@/js/components/DialogForm'

export default class DialogLogin extends DialogForm {
    name = 'login'

    onSubmitSuccess() {
        location.reload()
    }

    beforeShow() {
        location.hash = this.name
    }

    afterShow() {
        this.refs.form.querySelector('input[name="email"]').focus()
    }

    afterHide() {
        const hash = location.hash.substring(1)

        if (hash === this.name) {
            history.replaceState(null, null, ' ')
        }
    }
}
